module.exports = __webpack_public_path__ + "img/board-bg-dark-brown.cf589424.png";